import api from './api';

const funcionariosService = {
  async listar(params = {}) {
    const response = await api.get('/funcionarios', { params });
    return response.data;
  },

  async obterPorId(id) {
    const response = await api.get(`/funcionarios/${id}`);
    return response.data;
  },

  async criar(dados) {
    const response = await api.post('/funcionarios', dados);
    return response.data;
  },

  async atualizar(id, dados) {
    const response = await api.put(`/funcionarios/${id}`, dados);
    return response.data;
  },

  async excluir(id) {
    const response = await api.delete(`/funcionarios/${id}`);
    return response.data;
  }
};

export default funcionariosService;